// @ts-ignore
import newsletterFormFr from "./views/form.html?raw";
// @ts-ignore
import newsletterFormEn from "./views/form-en.html?raw";
// @ts-ignore
import summaryFr from "./views/summary.html?raw";
// @ts-ignore
import summaryEn from "./views/summary-en.html?raw";

import { newsletterService } from "./services/newsletter.service";
import { Eligibility } from "./models/newsletter.models";

import { NewsletterForm } from "./views/form";
import { NewsletterSummary } from "./views/summary";
import { authService } from "../auth/services/auth.service";

import './style/newsletter.css'
import { i18n } from "../core/services/i18n.service";

const getNewsletterIds = (container: HTMLElement): { frenchId: string, englishId: string } => {
    const frenchId = container.getAttribute("data-french-id");
    const englishId = container.getAttribute("data-english-id");
    if (!frenchId || !englishId) { throw new Error("Newsletter ids not found"); }

    return { frenchId, englishId };
}

const checkEligibility = async (newsletterIds: { frenchId: string, englishId: string }): Promise<Eligibility[]> => {
    const frenchEligibility: Eligibility = await newsletterService.checkEligibility(newsletterIds.frenchId);
    const englishEligibility: Eligibility = await newsletterService.checkEligibility(newsletterIds.englishId);

    return [frenchEligibility, englishEligibility];
}

const nlReaderHandler = async (newsletterIds: { frenchId: string, englishId: string }): Promise<void> => {
    try {
        const eligibilityResponse: Eligibility[] = await checkEligibility(newsletterIds);
        if (eligibilityResponse.length === 0) { throw new Error("Error while checking eligibility"); }

        const eligible: Eligibility[] = eligibilityResponse.filter((e) => e.eligible === false);
        if (eligible.length === 0) {
            const formTemplate = i18n.getLanguage() === "fr" ? newsletterFormFr : newsletterFormEn;
            const form = new NewsletterForm(formTemplate, newsletterIds.frenchId, newsletterIds.englishId);
            form.initialize();
            if(eligibilityResponse[0].email) {
                form.setEmailInputValue(eligibilityResponse[0].email);
            }
            return;
        }

        const summaryTemplate = i18n.getLanguage() === "fr" ? summaryFr : summaryEn;
        const summaryDiv = new NewsletterSummary(summaryTemplate, eligibilityResponse);
        summaryDiv.initialize();
    }
    catch (error) {
        console.error(error);
    }
}

const authLoginEventHandler = async (): Promise<void> => {
    const container = document.getElementById("newsletter-form-container");
    if (container) container.innerHTML = '';

    const newsletterContainer = document.getElementById("newsletter-ids");
    if (!newsletterContainer) { return; }

    const newsletterIds = getNewsletterIds(newsletterContainer);
    if (!newsletterIds.frenchId || !newsletterIds.englishId) { throw new Error("Newsletter ids not found"); }

    if (!authService.isAuthenticated && newsletterIds.frenchId === "3" && newsletterIds.englishId === "31") {
        const formTemplate = i18n.getLanguage() === "fr" ? newsletterFormFr : newsletterFormEn;
        const form = new NewsletterForm(formTemplate, newsletterIds.frenchId, newsletterIds.englishId);
        form.initialize();
        return;
    }
    if (authService.isAuthenticated) {
        await nlReaderHandler(newsletterIds);
    }
};

document.addEventListener("authChange", authLoginEventHandler);
